var App = App || {};

App.CrossPromoBand = (function ($) {
    "use strict";

    function init() {
        $(".component-crosspromo .crosspromo-desktop-image-wrapper").ZagParallax({ divisor: 3 });
        $(".component-crosspromo .crosspromo-mobile-image").ZagParallax({ divisor: 6 });
    }

    return {
        init: init
    };

})(jQuery);

$(function () {
    App.CrossPromoBand.init();
});